import { CompanyResponseDto } from '@planning/app/api'
import { FieldStore, ISubFormStore, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export class LogisticsSubFormStore implements ISubFormStore<any> {
  forwarder: FieldStore<CompanyResponseDto | null | undefined>
  shipper: FieldStore<CompanyResponseDto | null | undefined>
  consignee: FieldStore<string | null | undefined>

  bookingReference: FieldStore<string | null | undefined>
  billOfLadding: FieldStore<string | null | undefined>

  constructor() {
    this.forwarder = new FieldStore<CompanyResponseDto | null | undefined>(undefined)
    this.shipper = new FieldStore<CompanyResponseDto | null | undefined>(undefined)
    this.consignee = new FieldStore<string | null | undefined>(undefined)

    this.bookingReference = new FieldStore<string | null | undefined>(undefined)
    this.billOfLadding = new FieldStore<string | null | undefined>(undefined)

    makeObservable(this)
  }

  validate = () => {
    return validateSubForm(this)
  }

  get data() {
    return {
      shipper: this.shipper.data,
      forwarder: this.forwarder.data,
      consignee: this.consignee.data,
      bookingReference: this.bookingReference.data,
      billOfLadding: this.billOfLadding.data,
    }
  }
}
